/* eslint-disable no-debugger */
import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import {
  addSubcontractor,
  searchSubcontractor,
  getByEmailOfSub,
  inviteSubAdmin,
  getSubByname,
  cloneSubcontractor,
  assign,
  search,
  searchSubcontractorAssignments,
  selectListSubcontractor,
  searchAllSubcontractorSelectList,
  getSubById,
  resendInvite,
  assignTradeToSubcontractor,
  editSubcontractor,
  deleteInactiveSuperAdmin,
  getSubcontractorSuggestion,
  removeSuperAdminFromSubcontractor,
  removeSubcontractorAssignment,
  addContactPointSubcontractor,
  removeContactPointSubcontractor
} from './api';
import * as SubcontractorActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* getByEmailAsync(action) {
  const result = yield call(getByEmailOfSub, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_EMAIL_SUCCESS,
      data: { item: result.data, searchEmail: action.params }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSubByNameAsync(action) {
  const result = yield call(getSubByname, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_NAME_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* addSubcontractorAsync(action) {
  const result = yield call(addSubcontractor, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield all([
      put({
        type: SubcontractorActionType.ADD_SUBCONTRACTOR_SUCCESS,
        data: null
      }),
      put({
        type: NotifyActionType.NOTIFY_SUCCESS,
        data: 'Subcontractor created'
      })
    ]);
  } else {
    yield put({
      type: SubcontractorActionType.ADD_EDIT_SUBCONTRACTOR_ERROR,
      data: { error: result.data, params: action.params.data }
    });
  }
}

export function* editSubcontractorAsync(action) {
  const result = yield call(editSubcontractor, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield all([put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })]);
    if (action.callback) {
      action.callback(result.status, result.data);
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: 'Something wrong please contact adminstrator.'
    });
  }
}

export function* searchSubcontractorAsync(action) {
  const result = yield call(searchSubcontractor, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: SubcontractorActionType.SEARCH_SUBCONTRACTOR_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* inviteSubAdminAsync(action) {
  const result = yield call(inviteSubAdmin, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield all([
      put({
        type: SubcontractorActionType.INVITE_SUBCONTRACTOR_ADMIN_SUCCESS,
        data: null
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Invitation sent' })
    ]);
  } else {
    //TODO
  }
}

export function* cloneSubcontractorAsync(action) {
  const result = yield call(cloneSubcontractor, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.params.nextAction) {
      yield [
        put({
          type: SubcontractorActionType.ADD_SUBCONTRACTOR_SUCCESS,
          data: null
        }),
        put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
      ];
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* assignAsync(action) {
  const result = yield call(assign, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield all([
      put({
        type: SubcontractorActionType.ASSIGN_SUB_OF_PROJECT_SUCCESS,
        params: null
      }),
      put({
        type: SubcontractorActionType.SEARCH_SUB_OF_PROJECT_ASYNC,
        params: action.params.search
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Added' })
    ]);
  } else {
    console.warn('WatchSubOfProject createAsync ', result.data);
  }
}

export function* searchAsync(action) {
  const result = yield call(search, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield all([
      put({
        type: SubcontractorActionType.SEARCH_SUB_OF_PROJECT_SUCCESS,
        data: {
          data: result.data,
          params: action.params
        }
      })
    ]);
  } else {
    console.warn('WatchSubOfProject createAsync ', result.data);
  }
}

export function* searchSubcontractorAssignmentsAsync(action) {
  const result = yield call(searchSubcontractorAssignments, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield all([
      put({
        type:
          SubcontractorActionType.SEARCH_SUBCONTRACTOR_ASSIGNMENT_TO_PROJECT_SUCCESS,
        data: {
          data: result.data,
          params: action.params
        }
      })
    ]);
  } else {
    console.warn('WatchSubOfProject createAsync ', result.data);
  }
}

export function* selectSubcontractorAsync(action) {
  const result = yield call(selectListSubcontractor, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchAllSubcontractorSelectListAsync(action) {
  const result = yield call(searchAllSubcontractorSelectList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSubByIdAsync(action) {
  const result = yield call(getSubById, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* resendInviteAsync(action) {
  const result = yield call(resendInvite, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: 'Invitation sent'
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* assignTradeToSubcontractorAsync(action) {
  const result = yield call(assignTradeToSubcontractor, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' }),
      put({
        type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_ASYNC,
        params: {
          subId: action.params.subId
        }
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* deleteInactiveSuperAdminAsync(action) {
  const result = yield call(deleteInactiveSuperAdmin, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })];
    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSubcontractorSuggestionAsync(action) {
  const result = yield call(getSubcontractorSuggestion, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: SubcontractorActionType.GET_SUBCONTRACTOR_SUGGESTION_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* removeSuperAdminFromSubcontractorAsync(action) {
  const result = yield call(removeSuperAdminFromSubcontractor, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Removed' }),
      put({
        type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_ASYNC,
        params: action.params,
        callback: action.callback
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}
// Sub Assignment Remove
export function* removeSubcontractorAssignmentAsync(action) {
  const result = yield call(removeSubcontractorAssignment, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Removed'});
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: SubcontractorActionType.SUBCONTRACTOR_ASSIGNMENT_ERROR, data: result.data.error});
  }
}

export function* addContactPointSubcontractorAsync(action) {
  const result = yield call(addContactPointSubcontractor, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {

    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Added'})];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* removeContactPointSubcontractorAsync(action) {
  const result = yield call(removeContactPointSubcontractor, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      // put({ type: SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_SUCCESS, data: result.data}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Removed'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export default function* WatchSubcontractor() {
  yield all([
    takeLatest(
      SubcontractorActionType.GET_SUBCONTRACTOR_BY_EMAIL_ASYNC,
      getByEmailAsync
    ),
    takeLatest(
      SubcontractorActionType.GET_SUBCONTRACTOR_BY_NAME_ASYNC,
      getSubByNameAsync
    ),
    takeLatest(
      SubcontractorActionType.SEARCH_SUBCONTRACTOR_ASYNC,
      searchSubcontractorAsync
    ),
    takeEvery(
      SubcontractorActionType.ADD_SUBCONTRACTOR_ASYNC,
      addSubcontractorAsync
    ),
    takeEvery(
      SubcontractorActionType.INVITE_SUBCONTRACTOR_ADMIN_ASYNC,
      inviteSubAdminAsync
    ),
    takeEvery(
      SubcontractorActionType.CLONE_SUBCONTRACTOR_ASYNC,
      cloneSubcontractorAsync
    ),
    takeLatest(
      SubcontractorActionType.SEARCH_SUB_OF_PROJECT_ASYNC,
      searchAsync
    ),
    takeLatest(
      SubcontractorActionType.SEARCH_SUBCONTRACTOR_ASSIGNMENT_TO_PROJECT_ASYNC,
      searchSubcontractorAssignmentsAsync
    ),
    takeEvery(SubcontractorActionType.ASSIGN_SUB_OF_PROJECT_ASYNC, assignAsync),
    takeEvery(
      SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
      selectSubcontractorAsync
    ),
    takeEvery(
      SubcontractorActionType.SEARCH_ALL_SUBCONTRACTOR_SELECT_LIST,
      searchAllSubcontractorSelectListAsync
    ),
    takeLatest(
      SubcontractorActionType.GET_SUBCONTRACTOR_BY_ID_ASYNC,
      getSubByIdAsync
    ),
    takeLatest(
      SubcontractorActionType.RESEND_SUBCONTRACTOR_INVITE_ASYNC,
      resendInviteAsync
    ),
    takeLatest(
      SubcontractorActionType.ASSIGN_TRADE_TO_SUBCONTRACTOR_ASYNC,
      assignTradeToSubcontractorAsync
    ),
    takeLatest(
      SubcontractorActionType.EDIT_SUBCONTRACTOR_ASYNC,
      editSubcontractorAsync
    ),
    takeEvery(
      SubcontractorActionType.GET_SUBCONTRACTOR_SUGGESTION_ASYNC,
      getSubcontractorSuggestionAsync
    ),
    takeLatest(
      SubcontractorActionType.REMOVE_SUPER_ADMIN_FROM_SUBCONTRACTOR_ASYNC,
      removeSuperAdminFromSubcontractorAsync
    ),
    takeLatest(
      SubcontractorActionType.REMOVE_SUBCONTRACTOR_ASSIGNMENT_ASYNC,
      removeSubcontractorAssignmentAsync
    ),
    takeLatest(
      SubcontractorActionType.ADD_CONTACT_POINT_SUBCONTRACTOR_ASYNC,
      addContactPointSubcontractorAsync
    ),
    takeLatest(
      SubcontractorActionType.REMOVE_CONTACT_POINT_SUBCONTRACTOR_ASYNC,
      removeContactPointSubcontractorAsync
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/Subcontractors/saga.js